import { provideAppDestroy, type AppDestroy } from '@bcf-vanilla-ts-v1-shared/di/app-destroy';
import { provideSingleton } from '@bcf-vanilla-ts-v1-shared/di/provide-singleton';
import { filterIsTruthy } from '@bcf-vanilla-ts-v1-shared/misc/rx-operators/filter-is-truthy';
import {
  provideBcfActivatedRoute,
  type BcfActivatedRoute
} from '@bcf2-shared-pkg-v1/ui/shared/bcf-router/bcf-activated-route';
import {
  provideBcfRouterExternalRedirectorService,
  type BcfRouterExternalRedirectorService
} from '@bcf2-shared-pkg-v1/ui/shared/bcf-router/bcf-router-external-navigator.service';
import { provideCookiesService, type CookiesService } from '@bcf2-v1-ui-shared/cookies/cookies.service';
import { addDays } from 'date-fns';
import { distinctUntilChanged, map, pluck, skip, takeUntil, type Observable } from 'rxjs';

export class ChangedLangDetectorService {
  constructor(
    private _activatedRoute: BcfActivatedRoute,
    private _externalRedirectorService: BcfRouterExternalRedirectorService,
    private _cookies: CookiesService,
    private _appDestroy: AppDestroy,
    private _document: Document
  ) {}

  public init(): void {
    this._getRouterUrlAfterLangChanged()
      .pipe(takeUntil(this._appDestroy.destroy$))
      .subscribe((newUrl: string) => {
        this._externalRedirectorService.redirectToExternalUrl(newUrl);
      });

    this._getRouteLang()
      .pipe(takeUntil(this._appDestroy.destroy$))
      .subscribe((lang: string) => this._cookies.set('bcfDefaultLang', lang, addDays(new Date(), 31)));
  }

  private _getRouterUrlAfterLangChanged(): Observable<string> {
    return this._getRouteLang().pipe(
      skip(1),
      filterIsTruthy(),
      map(() => this._document.location.pathname)
    );
  }

  private _getRouteLang(): Observable<string> {
    return this._activatedRoute.data.pipe(pluck('routeLang'), filterIsTruthy(), distinctUntilChanged());
  }
}
export function provideChangedLangDetectorService(): ChangedLangDetectorService {
  return provideSingleton(
    ChangedLangDetectorService,
    () =>
      new ChangedLangDetectorService(
        provideBcfActivatedRoute(),
        provideBcfRouterExternalRedirectorService(),
        provideCookiesService(),
        provideAppDestroy(),
        document
      )
  );
}
